import {API_URL } from '../constants/index.js';
import {
    USER,
    USER_ERROR,
    USER_SUCCESS,
    ADD_USER,
    ADD_USER_ERROR,
    ADD_USER_SUCCESS,
    UPDATE_USER,
    UPDATE_USER_ERROR,
    UPDATE_USER_SUCCESS
} from '../constants/userConstants';
import {sweetAlert} from '../components/Alert/sweetAlert';

//#region GET USERS
export function getUser(data) {
    return {
        type: USER,
        data
    }
};

export function getUserSuccess(data) {
    return {
        type: USER_SUCCESS,
        data
    }
};

export function getUserError(data) {
    return {
        type: USER_ERROR,
        data
    }
};


export function GetAllUsers() {
    return dispatch => {
        dispatch(getUser());
      
       // dispatch(getUserSuccess(UserDetails))
        fetch(API_URL+'users/users',
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
            }
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getUserSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(getUserError(error));

            })
    }
};


export function GetUserById(id) {
    return dispatch => {
        dispatch(getUser());
      
       // dispatch(getUserSuccess(UserDetails))
        fetch(API_URL+'users/users/'+id,
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
            }
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getUserSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(getUserError(error));

            })
    }
};


//#endregion

//#region ADD USER
export function addUser(data) {
    return {
        type: ADD_USER,
        data
    }
};

export function addUserSuccess(data) {
    return {
        type: ADD_USER_SUCCESS,
        data
    }
};

export function addUserError(data) {
    return {
        type: ADD_USER_ERROR,
        data
    }
};


export function AddUser(data) {

    const profileKeyCloakObj = localStorage.getItem('ky')? JSON.parse(localStorage.getItem('ky')) : undefined;
    let profileObject = (profileKeyCloakObj && profileKeyCloakObj.profile)? profileKeyCloakObj.profile:  undefined;
    let userLogged = (profileObject && profileObject.username)?profileObject.username: undefined;


    return dispatch => {
        dispatch(addUser());
      
       // dispatch(getUserSuccess(UserDetails))
        fetch(API_URL+'users/users',
            {
                method: 'POST',
                body: JSON.stringify(data),
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token'),
                    'username':userLogged,
            }
            })
            .then(res => res.json())
            .then(res => {
                const message = `The user has been added successfully`

                dispatch(addUserSuccess(res));

                sweetAlert('success',message,'alert_AddUser_Success');
                return res;
            })
            .catch(error => {
                const message = `An error occurred when adding user`

                dispatch(addUserError(error));

                sweetAlert('error',message,'alert_AddUser_Error');

            })
    }
};


//#endregion

//#region UPDATE USER
export function updUser(data) {
    return {
        type: UPDATE_USER,
        data
    }
};

export function updUserSuccess(data) {
    return {
        type: UPDATE_USER_SUCCESS,
        data
    }
};

export function updUserError(data) {
    return {
        type: UPDATE_USER_ERROR,
        data
    }
};


export function UpdUser(id,data) {
    return dispatch => {
        dispatch(updUser());
      
       // dispatch(getUserSuccess(UserDetails))
        fetch(API_URL+'/users/users/'+id,
            {
                method: 'PUT',
                body: JSON.stringify(data),
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
            }
            })
            .then(res => {
                const message = `The user has been Updated successfully`

                dispatch(updUserSuccess(data));
                sweetAlert('success',message,'alert_UpdateUser_Success');

                return res;
            })
            .catch(error => {
                const message = `An error has occurred while Updating the user`

                dispatch(updUserError(error));
                
                sweetAlert('error',message,'alert_UpdateUser_Error');

            })
    }
};


export function ConfirmUserAccount(id, data) {
    return dispatch => {
        dispatch(updUser());
      
        fetch(API_URL+'/users/confirm/'+id,
            {
                method: 'PUT',
                body: JSON.stringify(data),
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
                }
            })
            .then(res => {
                const message = `The user has been confirmed successfully`

                dispatch(updUserSuccess(data));
                sweetAlert('success',message,'alert_ConfirmUserAccount_Success');
                return res;
            })
            .catch(error => {
                const message = `An error has occurred while Updating the user`

                dispatch(updUserError(error));
                
                sweetAlert('error',message,'alert_ConfirmUserAccount_Error');

            })
    }
};
//#endregion


